

















import { Component } from 'vue-property-decorator'
import UstraComponent from '@ustra/nuxt/src/vue/components/ustra-component'
import layoutDataEventBus from '@hds/help-common/src/event-bus/layout-data-event-bus'
import * as webUtils from '@ustra/core/src/utils/web-utils'
import HeaderBar from '~/components/layout/HeaderBar.vue'
import GnbRightDrawer from '~/components/layout/GnbRightDrawer.vue'
import HsVenCd from '~/components/common/hs-vencd.vue'
import HsSettingPush from '~/components/common/hs-pushnoti-setting.vue'
// 퍼블리싱 페이지 리스트
import PubList from '~/components/PubList.vue'

@Component({
  components: {
    HeaderBar,
    GnbRightDrawer,
    PubList,
    HsVenCd,
    HsSettingPush,
  },
  name: 'HSdefault',
})
export default class extends UstraComponent {
  // #region variables
  layoutTitle: string = ''
  layoutType: string = ''
  options: any = ''
  gnbDrawer: boolean = false
  isIos: boolean = webUtils.isIOsRequest()

  isDev = false
  isProduction = false

  // #endregion
  // #region hooks
  created() {
    if (process.env.CONFIG_ENV === 'production') {
      this.isDev = false
      this.isProduction = true
    } else {
      this.isDev = true
      this.isProduction = false
    }

    layoutDataEventBus.on((state) => {
      this.layoutTitle = state.title
      this.layoutType = state.layoutType || 'type2'
      this.options = state.options
    })
  }
  // #endregion

  // #region methods
  isGnbDrawer(state) {
    console.log('why ----', state)
    this.gnbDrawer = state
  }

  // #endregion
  // #region watches
  // #endregion
}
